module.exports = __webpack_public_path__ + "media/applicants/icon-progress-e6cf2d6d.png";